import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Shell } from "@/pages/Auth";
import { api, errMsg } from "@/lib/api";

const BackToLogin = () => <p className="text-sm text-muted-foreground mt-6"><Link to="/login" className="text-foreground underline" data-testid="back-to-login-link">Voltar para o login</Link></p>;

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { setSent((await api.post("/auth/forgot-password", { email })).data.message); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Shell title="Recuperar senha" sub="Informe o email da sua conta e enviaremos um link para criar uma senha nova.">
      {sent ? (
        <div className="surface p-5 flex gap-3" data-testid="forgot-password-sent"><MailCheck className="h-5 w-5 text-[#34A853] shrink-0 mt-0.5" /><p className="text-sm">{sent} Confira também a caixa de spam. O link vale por 1 hora.</p></div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
          <div><Label>Email</Label><Input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 mt-1.5" /></div>
          <Button data-testid="forgot-submit-button" disabled={busy} className="w-full h-11 rounded-full">{busy ? "Enviando..." : "Enviar link"}</Button>
        </form>
      )}
      <BackToLogin />
    </Shell>
  );
}

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [f, setF] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) { toast.error("As senhas não coincidem."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: f.password });
      toast.success("Senha redefinida. Entre com a senha nova.");
      nav("/login", { replace: true });
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  if (!token) return <Shell title="Link inválido" sub="Este link de redefinição está incompleto."><Link to="/esqueci-senha" className="underline text-sm" data-testid="request-new-link">Pedir um novo link</Link></Shell>;
  return (
    <Shell title="Criar senha nova" sub="Escolha uma senha com pelo menos 8 caracteres.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
        <div><Label>Nova senha</Label><Input data-testid="reset-password-input" type="password" minLength={8} required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="h-11 mt-1.5" /></div>
        <div><Label>Confirme a nova senha</Label><Input data-testid="reset-password-confirm-input" type="password" minLength={8} required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className="h-11 mt-1.5" /></div>
        <Button data-testid="reset-submit-button" disabled={busy} className="w-full h-11 rounded-full">{busy ? "Salvando..." : "Salvar senha nova"}</Button>
      </form>
      <BackToLogin />
    </Shell>
  );
}
